import React from 'react';
import PropTypes from 'prop-types';

import Icon from './icon';

const ButtonIcon = ({
	icon,
	label = '',
	title = '',
	type = '',
	onClick,
	onMouseEnter = null,
	classes = '',
	isDisabled = false,
	isSmall = false,
	iconRight = false,
	iconSpin = false,
}) => (
	<button
		className={`button__icon ${classes} ${isSmall ? 'is-small' : ''} ${type ? `is-${type}` : ''}`}
		disabled={isDisabled}
		onClick={onClick}
		onMouseEnter={onMouseEnter}
		type="button"
	>
		{!iconRight && (<Icon icon={icon} title={title} classes={`${label ? 'margin-right-4' : ''}`} spin={iconSpin} />)}
		{label && (
			<span className="button__icon-label">
				{label}
			</span>
		)}
		{iconRight && (<Icon icon={icon} title={title} classes={`${label ? 'margin-left-4' : ''}`} spin={iconSpin} />)}
	</button>
);

export default ButtonIcon;

ButtonIcon.propTypes = {
	icon: PropTypes.string.isRequired,
	label: PropTypes.string,
	title: PropTypes.string,
	type: PropTypes.string,
	onClick: PropTypes.func.isRequired,
	onMouseEnter: PropTypes.func,
	classes: PropTypes.string,
	isDisabled: PropTypes.bool,
	isSmall: PropTypes.bool,
	iconRight: PropTypes.bool,
	iconSpin: PropTypes.bool,
};
